<script>
import {
  config,
} from './config/index.js';

import wxBridge from './utils/wx-bridge.js';
import {
  Event
} from './utils/event.js';

import themeConfig from './config/theme-config.js';

//实例化
uni.event = new Event()
export default {
  onLaunch: function (data) {
    this.globalData.deviceInfo = uni.getSystemInfoSync();
    this.globalData.videoContainerSize = {
      width: this.globalData.deviceInfo.windowWidth,
      height: this.globalData.deviceInfo.windowHeight
    }
    //监听app.js发射的change事件,页面卸载的时候要停止监听event.off
    uni.event.on('initIm', function () {

    }, 'app')
  },
  onShow: function (data) {
    //加载数据
    this.initData(data)
  },
  onHide: function () {
  },
  methods: {
    //加载数据
    initData(data) {
      // 医保小程序授权后信息获取
      this.globalData.scene = data.scene;
      if (data.scene === 1038) {
        console.log('miniprogram back')
        uni.event.emit('miniProgramBack')
        if (data.referrerInfo.extraData && data.referrerInfo.extraData.authCode) {
          this.globalData.authCode = data.referrerInfo.extraData.authCode
          console.log('medicalInsuranceAuth', this.globalData.authCode)
          uni.event.emit('medicalInsuranceAuth')
        }
      }
      if (data.scene === 1038) { //跨账号特殊处理
        if (data.referrerInfo.extraData && data.referrerInfo.extraData.source === "crossAccount") {
          if (uni.getStorageSync('payReturnUrl') && uni.getStorageSync('payReturnUrl') === data.referrerInfo.extraData.returnUrl) {//判断支付是否处理过，处理过不在跳转
            return;
          } else {
            uni.setStorageSync('payReturnUrl', data.referrerInfo.extraData.returnUrl);
            uni.redirectTo({
              url: `/pages/web-view/index?url=${encodeURIComponent(data.referrerInfo.extraData.returnUrl)}`,
            });
          }
        }
      }
    },
    /**
     * 设置全局缓存
     * @param {Object} data
     */
    setGlobalData(data) {
      Object.keys(data).forEach(key => this.globalData[key] = data[key]);
      // 同步设置header头信息
      uni.setStorageSync('header', JSON.stringify(data));
    },
    /**
     * 还原全局变量&清空缓存
     */
    clearGlobalData() {
      try {
        if (uni.getStorageSync('header')) {
          uni.removeStorageSync('header');
        }
      } catch (e) {
      }
    },
  },
  globalData: {
    userInfo: wxBridge.getStorageSync('userInfo') ? JSON.parse(wxBridge.getStorageSync('userInfo')) : {
      user: {}
    },
    loginForm: wxBridge.getStorageSync(`${config.appCode}-loginForm`) ? JSON.parse(wxBridge.getStorageSync(`${config.appCode}-loginForm`)) : {
      role: '',
      orgId: '',
      personId: '',
      username: '',
      password: '',
      contact: '',
    },
    appId: config.appId,
    appCode: config.appCode,
    theme: config.theme || 'green',
    themeConfig: themeConfig[config.theme || 'green'],
    resourcesUrl: `https://minio.zykj.com/sxy-business-center/`,
    deviceInfo: {},
    videoContainerSize: {},
    menuButtonInfo: {},
    navBarHeight: 0,
    isIPhoneXSeries: false,
  },
}
</script>
<style>
/*每个页面公共css */
@import url('./app.wxss');
</style>
<style lang="scss">
/*每个页面公共css */
@import '@/uni_modules/uni-scss/index.scss';
</style>
